<mcg-window #ventana [loading]="loading()" [title]="windowTitle()" [actions]="actions"
  (actionButtonClicked)="actionButtonClicked($event)" (windowClosed)="closeWindow()">
  <app-header #header [exportar]="true" [buscador]="true" [filtro]="true" [resetFiltro]="true"
    (eventExportar)="onExportar()" (eventBuscador)="onBuscar()" (eventFilter)="eventFilter()"
    (eventResetFilter)="eventResetFilter()">
  </app-header>
  <jqxGrid #gridJobs [theme]="environment.tema" [height]="'calc(100% - 50px)'" [width]="'100%'"
    [source]="adapterJobs"  [appCellClick] [columnsresize]="true" [localization]="langGrid" [filterable]="true"
    [showfilterrow]="false" [columns]="columnsJobs" [showrowlines]="false" [showcolumnlines]="true" [groupsheaderheight]="25"
    [pageable]="false" [enablebrowserselection]="true" [sortable]="true" [altrows]="true" [showstatusbar]="false"
    [showaggregates]="true" [rowsheight]="25" [columnsheight]="30" [enabletooltips]="false" [groupable]="true"
    [groupsrenderer]="groupsrenderer" [editable]="editable" [filter]="filter" [updatefilterconditions]="updatefilterconditions"
    (onGroupschanged)="resizeColumns()" (onCellclick)="onCellClick($event)" (onRowdoubleclick)="onRowdoubleclick($event)"
    (onCellvaluechanged)="onCellvaluechanged($event)" (onFilter)="onFilter($event)" (onBindingcomplete)="onBindingComplete()">
  </jqxGrid>
</mcg-window>

<div #formJob></div>
